export const points = [
  {
    name: "4x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: [
      "0x4c0AF5d6Bcb10B3C05FB5F3a846999a3d87534C7",
      "0x2De851E60e428106fC98fE94017466F8D71793d1",
      "0xEeb63D2d370C5318ef174D366A41507F9380f093",
      "0xF3c631B979EB59d8333374baA7c58B5Aff5e24D2",
    ],
  },
  {
    name: "6x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: [
      "0x3D9e5462A940684073EED7e4a13d19AE0Dcd13bc",
      "0xeEb1DC1Ca7ffC5b54aD1cc4c1088Db4E5657Cb6c",
    ],
  },
  {
    name: "2x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: ["0x2ad7546A19eb5D5eDb37EC88A4775995078d1CAd"],
  },
  {
    name: "2x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: ["0xa5cd24d9792F4F131f5976Af935A505D19c8Db2b"],
  },
  {
    name: "6x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: [
      "0x196F3C7443E940911EE2Bb88e019Fd71400349D9",
      "0xB38D431e932fEa77d1dF0AE0dFE4400c97e597B8",
      "0x1cDA7E7B2023C3f3c94Aa1999937358fA9D01Aab",
    ],
  },
  {
    name: "4x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: [
      "0x0806af1762Bdd85B167825ab1a64E31CF9497038",
      "0x05d57366B862022F76Fe93316e81E9f24218bBfC",
      "0x9144C0F0614dD0acE859C61CC37e5386d2Ada43A",
      "0xeeaaB5c863f4b1c5356aF138F384AdC25Cb70Da6",
      "0x6f2Ab32A6487A2996c74Ed2b173dFDF3d5EEDB58",
    ],
  },
  {
    name: "4x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: ["0x1E1482E7Bc32cD085d7aF61F29019Ba372B63277"],
  },
  {
    name: "4x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: [
      "0x90a804D316A06E00755444D56b9eF52e5C4F4D73",
      "0x6832F3090867449c058e1e3088E552E12AB18F9E",
    ],
  },
  {
    name: "10x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: ["0x6F11663766bB213003cD74EB09ff4c67145023c5"],
    entity: ["mev-capital"],
  },
  {
    name: "12x Sonic Points",
    logo: "/points/sonic.png",
    collateralVaults: ["0xC37fa1c70D77bdEd373C551a92bAbcee44a9d04E"],
    entity: ["mev-capital"],
  },
  {
    name: "up to 10x Trevee points",
    logo: "/points/trevee.svg",
    collateralVaults: [
      "0xB38D431e932fEa77d1dF0AE0dFE4400c97e597B8",
      "0xeEb1DC1Ca7ffC5b54aD1cc4c1088Db4E5657Cb6c",
      "0x05d57366B862022F76Fe93316e81E9f24218bBfC",
    ],
  },
  {
    name: "up to 5x Trevee points",
    logo: "/points/trevee.svg",
    collateralVaults: [
      "0x0806af1762Bdd85B167825ab1a64E31CF9497038",
      "0xEeb63D2d370C5318ef174D366A41507F9380f093",
    ],
  },
  {
    name: "up to 20x Trevee points",
    logo: "/points/trevee.svg",
    collateralVaults: ["0x1cDA7E7B2023C3f3c94Aa1999937358fA9D01Aab"],
  },
] as const
